var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVodafoneIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1478 7.02797C31.1478 9.04066 29.5164 10.6722 27.5036 10.6722C25.491 10.6722 23.8594 9.04066 23.8594 7.02797C23.8594 5.01534 25.491 3.38379 27.5036 3.38379C29.5164 3.38379 31.1478 5.01534 31.1478 7.02797Z",
    fill: "url(#paint0_radial_18175_420740)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1478 7.02797C31.1478 9.04066 29.5164 10.6722 27.5036 10.6722C25.491 10.6722 23.8594 9.04066 23.8594 7.02797C23.8594 5.01534 25.491 3.38379 27.5036 3.38379C29.5164 3.38379 31.1478 5.01534 31.1478 7.02797Z",
    fill: "url(#paint1_radial_18175_420740)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.993 12.6562H24.625V30.5657H30.993V12.6562Z",
    fill: "#EE2737"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38224 30.6902H13.7031L9.19387 12.7812H2.81641L7.38224 30.6902Z",
    fill: "#EE2737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1529 30.6902H11.832L16.3413 12.7812H22.7187L18.1529 30.6902Z",
    fill: "#EE2737"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18175_420740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2549 5.84624) rotate(147.734) scale(5.96677 5.13533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887575,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518773,
    stopColor: "#FFE31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711611,
    stopColor: "#F2BC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831973,
    stopColor: "#D89500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953471,
    stopColor: "#B46100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_18175_420740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.51095 -0.909052 1.33691 2.22211 28.9 5.76107)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325797,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451026,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955086,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodafoneIdea);
export default __webpack_public_path__ + "static/media/Vodafone_Idea.5c6f0bcd847d47cd12946befde05789b.svg";
export { ForwardRef as ReactComponent };